

export  const Answer=[
    ["1",
     "ans",
     "dummy",
     "dummy",
     "dummy"
],
    ["2",
    
        "dummy",
        "ans",
        "dummy",
        "dummy"
    ],["3",
        "dummy",
        "dummy",
        "ans",
        "dummy"
    ],
       ["4",
        "dummy",
        "ans",
        "dummy",
        "dummy"
       ]

]

